import { formatPhoneNumber } from '../../../../../../utils/formatPhoneNumber';

export const pensionerListContent = (
  {
    address,
    phone_number,
    email,
    is_animals,
    is_smoker,
    liked_animals_types,
    moving_with_animal,
    animals_experiences
  },
  t
) => [
  {
    label: t('profile.form.address'),
    content: address
      ? `${address?.number || ''} ${address?.street || ''}, ${
          address?.additional || ''
        } ${address?.postal_code || ''}, ${address?.city || ''}, ${
          address?.country || ''
        }`
      : '-'
  },
  {
    label: t('profile.personal_info.country'),
    content: address?.country || '-'
  },
  {
    label: t('profile.personal_info.phone_number'),
    content: phone_number?.number ? formatPhoneNumber(phone_number) : '-'
  },
  {
    label: t('profile.personal_info.email'),
    content: email || '-'
  },
  {
    label: t('profile.personal_info.have_animals'),
    content: is_animals
      ? t('profile.personal_info.yes')
      : t('profile.personal_info.no') || '-'
  },
  ...(is_animals && liked_animals_types?.length
    ? [
        {
          label: t('profile.personal_info.liked_animals_types'),
          content: liked_animals_types
            .map((type) => t(`animals.tags.${type}`))
            .join(', ')
        }
      ]
    : []),
  {
    label: t('profile.personal_info.moving_with_animal'),
    content: moving_with_animal
      ? t('profile.personal_info.yes')
      : t('profile.personal_info.no') || '-'
  },
  ...(moving_with_animal && animals_experiences
    ? [
        {
          label: t('pensioners.form.animals_experiences'),
          content: animals_experiences
        }
      ]
    : []),
  {
    label: t('profile.personal_info.is_smoker'),
    content: is_smoker
      ? t('profile.personal_info.yes')
      : t('profile.personal_info.no') || '-'
  }
];
